import React from 'react';
import classNames from 'classnames';
import {
  Menu,
  MenuButton,
  MenuPopover,
  MenuList,
  MenuItem,
  MenuTrigger,
  Body1 as Text,
  Tooltip,
} from '@fluentui/react-components';
import { METRIC_OPTIONS } from '@bingads-webui-campaign-react/top-locations-card-const';

import { useMetricSelectorStyles } from '../styles/metric-selector-styles';
import { MetricSelectorProps } from '../utils/types';
import { METRIC_STRINGS, METRIC_FULL_STRINGS } from '../utils/const';

export function MetricSelector({
  metric,
  onMetricChange,
  i18n,
}: MetricSelectorProps) {
  const styles = useMetricSelectorStyles();

  return (
    <div className={classNames('metric-selector', styles.container)}>
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <Tooltip content={i18n.getString(METRIC_FULL_STRINGS[metric])} relationship="description">
            <MenuButton className={classNames('select-view', styles.button)} appearance="transparent">
              <div className={styles.iconContainer}>
                <div className={styles.icon} />
              </div>
              <Text className={classNames('current-selection-text', styles.buttonText)}>{i18n.getString(METRIC_STRINGS[metric])}</Text>
            </MenuButton>
          </Tooltip>
        </MenuTrigger>
        <MenuPopover className="view-options">
          <MenuList>
            {METRIC_OPTIONS.map(option => (<MenuItem className={option} key={option} onClick={() => onMetricChange(option)}>{i18n.getString(METRIC_STRINGS[option])}</MenuItem>))}
          </MenuList>
        </MenuPopover>
      </Menu>
    </div>
  );
}
